module.exports = __webpack_public_path__ + "static/media/mastercard.1a7f6653.svg";